import List from './List';
import Edit from './Edit';

export const Analytics = {
  List,
  Edit,
};
